import React from 'react';
import {ReactComponent as SpinLoaderIcon} from '../../assets/images/loader.svg';

export const Loader: React.FC = () => (
  <div className="screen-height grid place-items-center bg-black">
    <SpinLoaderIcon className="h-10 w-10 animate-spin" />
  </div>
);
